import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {
  CreateDefaultPlanModal,
  EditDefaultPlanModal,
  DefaultPlanListFilters,
} from "@modules/defaultPlans/components";

import { useDefaultPlanList } from "./controller";
import { useDefaultPlanListColumns } from "./columns";

export const DefaultPlanList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createDefaultPlanModalRef,
    editDefaultPlanModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useDefaultPlanList();

  const columns = useDefaultPlanListColumns(
    refetch,
    translate,
    editDefaultPlanModalRef
  );

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <DefaultPlanListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="default-plans.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton
            onClick={() => createDefaultPlanModalRef.current?.open()}
          />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateDefaultPlanModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={createDefaultPlanModalRef}
      />
      <EditDefaultPlanModal
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
        modalRef={editDefaultPlanModalRef}
      />
    </List>
  );
});
